// extracted by mini-css-extract-plugin
export var container = "Y_b";
export var device = "Y_ds";
export var deviceContainer = "Y_dr";
export var icon = "Y_bv";
export var icons = "Y_bw";
export var image = "Y_g";
export var logo = "Y_bn";
export var model = "Y_dt";
export var section = "Y_d";